(function (appSetup) {

	appSetup.initConfiguration = function (app) {

		var config = {
			blockOrders: pcTrunk.blockOrders,
            blockQuotes: pcTrunk.blockQuotes,
            turnOffPriceAndAvailability: pcTrunk.turnOffPriceAndAvailability,
			commonResourcePath: pcTrunk.commonResourcePath,
			contextPath: pcTrunk.contextPath,
			token: pcTrunk.CSRFToken,
			gaId: pcTrunk.gaId,
			user: {
				role: pcTrunk.userRole,
				firstName: pcTrunk.firstName,
				lastName: pcTrunk.lastName,
				id: pcTrunk.userId,
				email: pcTrunk.userEmail,
				isGridUser: pcTrunk.isGridUser,
				rmRole: pcTrunk.rmRole,
				companyName: pcTrunk.companyName,
				country: pcTrunk.country,
				phone: pcTrunk.phone,
				isEndUser: pcTrunk.isEndUser
			},
			currentYear: pcTrunk.currentYear,
			gsCategories: pcTrunk.gsCategories,
			isSapEnabled: pcTrunk.isSapEnabled,
			isSmallMotorsEnabled: pcTrunk.isSmallMotorsEnabled,
			isCustomMotorsEnabled: pcTrunk.isCustomMotorsEnabled,
			isInternalUserforLeadTime:pcTrunk.isInternalUserforLeadTime,
			isPartsPlusEnabled: pcTrunk.isPartsPlusEnabled,
			isMotorsModelEnabled: pcTrunk.isMotorsModelEnabled,
			isVisistatEnabled: pcTrunk.isVisistatEnabled,
			rmHomeContentShort: $.parseHTML(pcTrunk.rmHomeContentShort),
			rmHomeContentLong: $.parseHTML(pcTrunk.rmHomeContentLong),
			invResultsPageSize: pcTrunk.invResultsPageSize,
			timeToSessionRefresh: 600000,
			mocking: false,
			caching: true,
			isInventoryAdmin:pcTrunk.isInventoryAdmin,
			directCurMotorInv:pcTrunk.directCurMotorInv
		};

		var constants = {
			// categorize 
			messages: {
				noB2bUnitSelected: "Please, set your customer index first.",
				noItemsChecked: "Please, check some items to perform this action.",
				feedbackSuccess: "Your feedback submitted successfully!",
				feedbackError: "Error sending feedback.",
				cartItemsError: "Error occured while loading your cart items. Please, refresh the page.",
				serverError: "Server error occurred. We apologize for the inconvenience.",
				whereToBuyEmpty: "Sorry! No records found with your search criteria. Please use another criteria to begin a new search.",
				cartRemoveItemsError: "Error occured while removing item from your cart.",
				nuclearWarning: "Sorry! You cannot proceed with the order. Please contact your WOLONG Sales Manager.",
				formError: "Please, fill all required fields.",
				blockCanOrderError: "Orders shippable to Canada are serviced through different process, please reach out to your sales representative for more details",
				cartPandaNoB2bUnit: "Please, set your Customer Index No to get latest Price and Availability.",
				supportDocAddedToFav: "Item successfully added to your Favourites.",
				supportDocRemovedFromFav: "Item successfully removed from your Favourites.",
				registrationComplete: "Registration completed, yaaay!",
				registrationError: "Error occurred during registration process.",
				checkoutConfirmTerms: "You must confirm Terms and Condition to proceed.",
				cartMustBeEmpty: "Your cart must be empty for this action.",
				orderSaved: "Your order was successfully saved.",
				orderCancelled: "Your Order was Successfully Cancelled.",
				noResults: "Cant find items by your criteria.",
				cartIsEmpty: "Your cart is empty.",
				noProductsForPanda: "Not applicable for selected products.",
				unitTypeIsNotAllowed: "Please confirm your customer index number is set. If the issue persists please contact <a href='mailto:ecommercesupport@wolongamerica.com' target='_blank'>Technical Support</a>",
				noRoleOrB2bRights: "Sorry you’re not setup to perform this operation, please contact your sales manager.",
				underConstruction: "We are sorry, this feature is under construction.",
				lastProductInQuote: "It is the last product in Quote, are you sure you want to delete it? The quote will be deleted too.",
				sessionTimeout: "Your session has expired. You will now be redirected to update session data.",
				noCatalogAccessErrorMsg: "You currently do not have access to this portion of our product catalog.  Please contact your WOLONG Account Representative or use Contact Us to obtain access",
				contactUsFormSuccess: "Your request has been submitted successfully. You will be contacted shortly.",
				cart: {
					removeCartItems: "Are you sure you want to delete selected items from the cart ?"
				},
				orderCheckout:
				{
					mandatoryKits: "Please add mandatory kit(s) for the product(s)"
				},
				checkoutProfile: {
					profileCreated: "Quick Checkout Profile was successfully created.",
					profileApplied: "Quick Checkout Profile was successfully applied.",
				},
				unit: {
					unitIsInvalid: "Selected unit is not accessible."
				},
				emailNotification: {
					preferencesSaved: "Preferences were updated successfully."
				},
				search: {
					noCompCatValue: "You must fill in competitive catalog model number or keywords in the Filter by Keyword field"
				},
				customerRating: {
					noStarSelected: "Please, select an amount of stars to rate the order."
				}
			},
			footer: {
				compact: "compact",
				extended: "extended"
			},
			emails: {
				support: "ecommercesupport@wolongamerica.com",
				// one for everyone or sales manager dependent?
				mvQuoteEmail: "PCMVMotorsN37@ge.com"
			},
			url: {
				login: config.contextPath + "/user/login",
				optionsForAdvancedSearch: config.contextPath + "/search/loadsearchpopup",
				search: config.contextPath + "/search",
				customerRating: {
					saveOrderRating: config.contextPath + "/checkout/saveCustomerRating",
				},
				emailNotification: {
					validateUnit: config.contextPath + "/company/b2b",
					getPreferences: config.contextPath + "/notification/preference",
					savePreferences: config.contextPath + "/notification/preference",
				},
				whereToBuy: {
					searchStores: config.contextPath + "/getStoreLocations",
				},
				searchResults: {
					getLvMotorsFilterOptions: config.contextPath + "/search/loadsearchpopup",
					getPcPartsFilterOptions: config.contextPath + "/search/getPartsFilters",
					search: config.contextPath + "/search",
					getSubCategoriesForCode: config.contextPath + "/search/getSubCategoriesForCode"
				},
				dataPack: {
					word: config.contextPath + "/dataPack/downloadDataDoc?",
					pdf: config.contextPath + "/dataPack/downloadDataPdf?",
					base: config.contextPath + "/dataPack/downloadData?",
					archive: config.contextPath + "/dataPack/archive?"
				},
				orders: {
					search: config.contextPath + "/orders/search",
					getSavedOrders: config.contextPath + "/orders/savedorders",
					editSavedOrder: config.contextPath + "/cart/editsavedorder",
					deleteSavedOrder: config.contextPath + "/orders/deleteSaveOrder",
					getOrder: config.contextPath + "/orders/details",
					getStatusFilters: config.contextPath + "/orders/statuses",
					downloadAsPdf: config.contextPath + "/orders/exportPdf?",
				},
				quotes: {
					search: config.contextPath + "/quote/quoteSearch",
					downloadAsWord: config.contextPath + "/quote/exportworddoc?",
					downloadAsPdf: config.contextPath + "/quote/exportPdf?",
					getQuote: config.contextPath + "/quote/details",
					delete: config.contextPath + "/quote/delete",
					removeEntry: config.contextPath + "/quote/removeEntry",
				},
				cart: {
					get: config.contextPath + "/cart",
					addProducts: config.contextPath + "/cart/add",
					addOrder: config.contextPath + "/cart/add/order",
					convertQuote: config.contextPath +"/cart/convertQuote",
					remove: config.contextPath + "/cart/removeentry",
					removeByPk: config.contextPath + "/cart/remove",
					update: config.contextPath + "/cart/update",
					detachOrderFromCart: config.contextPath + "/cart/reset",
				},
				panda: {
					checkPriceAndAvailability: config.contextPath + "/product/checkAvailability",
					sendFeedback: config.contextPath + "/product/saveNonStockFeedback"
				},
				index: {
					sendRMContactFeedback: config.contextPath + "/saveRMContactFeedback"
				},
				b2bUnit: {
					changeUnit: config.contextPath + "/cart/assignCustomerToCart",
					search: config.contextPath + "/cart/searchB2BCustomers",
					getAvailableUnits: config.contextPath + "/units",
					getShippingAddresses: config.contextPath + "/checkout/displayDropShipAddress",
					getBillingAddresses: config.contextPath + "/checkout/displayBillToAddress",
				},
				orderCheckout: {
					getShipmentTypes: config.contextPath + "/checkout/shipmentMethods",
					getShipmentMethods: config.contextPath + "/checkout/populateShipPaymentMethod",
					getShipmentCarriers: config.contextPath + "/checkout/populateCarrierTypes",
					getThirdPartyAddresses: config.contextPath + "/checkout/displayThirdPartAddress",
					createOrSetThirdPartyAddress: config.contextPath + "/checkout/setthirdpartyaddress",
					createOrSetShippingAddress: config.contextPath + "/checkout/setshiptoaddress",
					saveShippingDetails: config.contextPath + "/checkout/saveShippingDetails",
					setBillingAddress: config.contextPath + "/checkout/setbilltoaddress",
					confirmCheckout: config.contextPath + "/checkout/conformationCheckout",
					saveOrder: config.contextPath + "/checkout/savecartfororder",
					cancelOrder: config.contextPath + "/checkout/cancelQuoteToOrderConversion",
					initCheckout: config.contextPath + "/checkout/initCheckout",
					deleteThirdPartyAddress: config.contextPath + "/checkout/deletethirdpartyaddress",
				},
				checkoutProfile: {
					getProfiles: config.contextPath + "/quickCheckoutProfile/showProfiles",
					getProfile: config.contextPath + "/quickCheckoutProfile/getProfile",
					applyProfile: config.contextPath + "/checkout/loadQuickProfile",
					saveOrderAsProfile: config.contextPath + "/checkout/savecartforquickcheckout",
					deleteProfile: config.contextPath + "/quickCheckoutProfile/deleteProfile",
					updateProfile: config.contextPath + "/quickCheckoutProfile/saveProfile",
				},
				quoteCheckout: {
					checkoutQuote: config.contextPath + "/quote/checkout/quote",
					saveAndReviewQuote: config.contextPath + "/quote/checkout/save",
					reviewQuote: config.contextPath + "/quote/checkout/review",
					confirmQuote: config.contextPath + "/quote/checkout/placeorder",
				},
				supportLibrary: {
					getFirstCat: config.contextPath + "/contentsearch/categories",
					getSecondCat: config.contextPath + "/contentsearch/subCategories",
					getLiterature: config.contextPath + "/contentsearch/literaturetypes",
					searchDocs: config.contextPath + "/contentsearch/search",
					searchFavourites: config.contextPath + "/favorites/view",
					addToFavourites: config.contextPath + "/favorites/add",
					removeFromFavourites: config.contextPath + "/favorites/remove",
				},
				registration: {
					getRoles: config.contextPath + "/user/login/getUserGroups",
					getSalesManagers: config.contextPath + "/dispSalesRep",
					getBuyerTypes: config.contextPath + "/user/login/getBuyerTypes",
					registerCustomer: config.contextPath + "/customer/registerCustomer",
				},
				common: {
					getCountries: config.contextPath + "/checkout/countries",
					getCountriesForDropship: config.contextPath + "/checkout/countries/dropship",
					getStates: config.contextPath + "/cart/loadRegionsForCountryIso",
					keepAlive: config.contextPath + "/keepAlive",
					shibbolethLogout: "/Shibboleth.sso/Logout"
				},
				mvMotorDetails: {
					requestQuote: config.contextPath + "/mvmotorquote/add"
				}
			},
			links: {
				contactUs: pcTrunk.contactUsLink,
				inventoryReportLink: "/rmstorefront/search-results?searchBy=catalog&pageNumber=1&searchResults=10&search=",
				error: "/rmstorefront/error",
				login: "/rmstorefront/rm/en/USD/user/login",
				logout: "/rmstorefront/rm/en/USD/logout",
				admin: "/rmstorefront/admin/registrationRequests",
				index: "/rmstorefront",
				registration: "/rmstorefront/register",
				ordersOverview: "/rmstorefront/orders-overview",
				orderDetails: "/rmstorefront/order-details?code=",
				quotesOverview: "/rmstorefront/quotes-overview",
				quoteDetails: "/rmstorefront/quote-details?code=",
				exportQuotesToExcel: "/rmstorefront/quote/exportExcel",
				searchResults: "/rmstorefront/search-results",
				searchGoToLvMotors: "/rmstorefront/search-results?searchBy=motors&value=&isTypeLocked=1",
				searchGoToPcParts: "/rmstorefront/search-results?searchBy=parts&value=&isTypeLocked=1",
				searchGoToPcPartsGrid: "/rmstorefront/search-results?searchBy=parts&value=grid&isTypeLocked=1&categoryCode=CAT10010",
				searchGoToAllParts: "/rmstorefront/search-results?searchBy=catalog&pageNumber=1&searchResults=10",
				mvMotorsOverview: "/rmstorefront/mv-motors-overview",
				mvMotorDetails: "/rmstorefront/mv-motor-details",
				checkoutProfile: "/rmstorefront/quick-checkout-profile",
				myAccount: "/rmstorefront/my-account/profile",
				cartOverview: "/rmstorefront/shopping-cart",
				orderCheckout: "/rmstorefront/order-checkout",
				quoteCheckout: "/rmstorefront/rmstorefront/quote-checkout",
				supportLibrary: "/rmstorefront/support-library",
				ebgMotors: "/EnetEBG/Dispatcher",
				//ebgMotorsMultiple: "/rmstorefront/ebgMotors/multiple",
				motorsModelSearch: "/EnetMMS/Dispatcher",
				smallMotors: "/rmstorefront/smallMotors",
				loginToPartsPlus: pcTrunk.partsPlusUrl,
				afterHours: "/rmstorefront/after-hours",
				siteMap: "/rmstorefront/site-map",
				 terms: "https://www.wolongamerica.com/terms",
				//terms: config.commonResourcePath + "/files/ES104_Quote_Terms.pdf",
				downloadClearancePdf: config.commonResourcePath + "/files/clearance.pdf",
				exportOrdersToExcel:"/rmstorefront/orders/exportExcel",
				exportOpenOrdersToExcel:"/rmstorefront/orders/exportOpenOrderExcel",
				pcStoreReviewPamphletPdf:config.commonResourcePath + "/files/StoreReviewPamphlet.pdf",
				pcStoreCreateQuoteAndOrderVideo:config.commonResourcePath + "/files/PCStore201.mp4",
				pcStoreHowToRegisterPdf:config.commonResourcePath + "/files/PCStoreHowToRegister.pdf",
				pcStoreHowToRegisterVideo:config.commonResourcePath + "/files/PCStore101.mp4"
			}
		};

		var pages = {
			index: {
				controller: ["index"],
				services: [],
				title: "index",
				displayTitle: "Home page",
				template: null,
				bodyStyle: "post-login bg-body-img",
				paths: ["", constants.links.index, "/rmstorefront/", "/rmstorefront/rm/en/USD/"],
				access: ["guest", "user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.extended,
				get path() {
					return this.paths[2];
				}
			},
			searchResults: {
				controller: ["searchResults"],
				services: [],
				title: "searchResults",
				displayTitle: "Search results",
				template: null,
				bodyStyle: "search-results-page bg-body-img",
				paths: [constants.links.searchResults, "/rmstorefront/search-results", "/rmstorefront/rm/en/USD/search-results"],
				access: ["guest", "user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			productDetails: {
				controller: ["productDetails"],
				services: [],
				title: "productDetails",
				displayTitle: "Product details",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [],
				access: ["guest", "user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[0];
				}
			},
			ordersOverview: {
				controller: ["ordersOverview"],
				services: [],
				title: "ordersOverview",
				displayTitle: "Orders overview",
				template: null,
				bodyStyle: "orders-page bg-body-img",
				paths: [constants.links.ordersOverview, "/rmstorefront/orders-overview", "/rmstorefront/rm/en/USD/orders-overview"],
				access: ["external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			quotesOverview: {
				controller: ["quotesOverview"],
				services: [],
				title: "quotesOverview",
				displayTitle: "Quotes overview",
				template: null,
				bodyStyle: "quotes-page bg-body-img",
				paths: [constants.links.quotesOverview, "/rmstorefront/quotes-overview", "/rmstorefront/rm/en/USD/quotes-overview"],
				access: ["epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			cart: {
				controller: ["cartOverview"],
				services: ["cartCheckout"],
				title: "cartOverview",
				displayTitle: "Cart",
				template: null,
				bodyStyle: "cart-page bg-body-img",
				paths: [constants.links.cartOverview, "/rmstorefront/shopping-cart", "/rmstorefront/rm/en/USD/shopping-cart"],
				access: ["user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			mvmOverview: {
				controller: ["mvmOverview"],
				services: [],
				title: "mvmOverview",
				displayTitle: "MV Motors",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.mvMotorsOverview, "/rmstorefront/mv-motors-overview", "/rmstorefront/rm/en/USD/mv-motors-overview"],
				access: ["guest", "user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			orderCheckout: {
				controller: ["orderCheckout"],
				services: ["customerRating"],
				title: "orderCheckout",
				displayTitle: "Order checkout",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.orderCheckout, "/rmstorefront/order-checkout", "/rmstorefront/rm/en/USD/order-checkout"],
				access: ["external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			quoteCheckout: {
				controller: ["quoteCheckout"],
				services: [],
				title: "quoteCheckout",
				displayTitle: "Generate quote",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.quoteCheckout, "/rmstorefront/quote-checkout", "/rmstorefront/rm/en/USD/quote-checkout"],
				access: ["epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			orderDetails: {
				controller: ["orderDetails"],
				services: [],
				title: "orderDetails",
				displayTitle: "Order details",
				template: null,
				bodyStyle: "cart-page bg-body-img",
				paths: [constants.links.orderDetails, "/rmstorefront/order-details", "/rmstorefront/rm/en/USD/order-details"],
				access: ["external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			quoteDetails: {
				controller: ["quoteDetails"],
				services: [],
				title: "quoteDetails",
				displayTitle: "Quote details",
				template: null,
				bodyStyle: "cart-page bg-body-img",
				paths: [constants.links.quoteDetails, "/rmstorefront/quote-details", "/rmstorefront/rm/en/USD/quote-details"],
				access: ["epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			supportLibrary: {
				controller: ["supportLibrary"],
				services: [],
				title: "supportLibrary",
				displayTitle: "Support library",
				template: null,
				bodyStyle: "admin-landing-page bg-body-img",
				paths: [constants.links.supportLibrary, "/rmstorefront/support-library", "/rmstorefront/rm/en/USD/support-library"],
				access: ["guest","user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			registration: {
				controller: ["registration"],
				services: [],
				title: "registration",
				displayTitle: "Registration",
				template: null,
				bodyStyle: "pre-login-banner",
				paths: [constants.links.registration, "/rmstorefront/register", "/rmstorefront/rm/en/USD/register"],
				access: ["guest"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			mvMotorDetails: {
				controller: ["mvMotorDetails"],
				services: [],
				title: "mvMotorDetails",
				displayTitle: "MV Motor details",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.mvMotorDetails, "/rmstorefront/mv-motor-details", "/rmstorefront/rm/en/USD/mv-motor-details"],
				access: ["user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			checkoutProfile: {
				controller: ["checkoutProfile"],
				services: [],
				title: "checkoutProfile",
				displayTitle: "Quick checkout profile",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.checkoutProfile, "/rmstorefront/quick-checkout-profile", "/rmstorefront/rm/en/USD/quick-checkout-profile"],
				access: ["user", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			afterHours: {
				controller: ["afterHours"],
				services: [],
				title: "afterHours",
				displayTitle: "After hours shipping",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.afterHours, "/rmstorefront/after-hours", "/rmstorefront/rm/en/USD/after-hours"],
				access: ["guest", "user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			siteMap: {
				controller: ["siteMap"],
				services: [],
				title: "siteMap",
				displayTitle: "Site map",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.siteMap, "/rmstorefront/site-map", "/rmstorefront/rm/en/USD/site-map"],
				access: ["user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
			error: {
				controller: ["errorPage"],
				services: [],
				title: "errorPage",
				displayTitle: "Error",
				template: null,
				bodyStyle: "bg-body-img",
				paths: [constants.links.error, "/rmstorefront/error", "/rmstorefront/rm/en/USD/j_spring_security_check"],
				access: ["guest", "user", "consultant", "epc", "external", "internal", "superUser"],
				footerType: constants.footer.compact,
				get path() {
					return this.paths[1];
				}
			},
		};

		var stash = {
			queryData: {},
			// product from searchResults
			selectedProduct: {},
			// initial data below
			cart: {
				size: pcTrunk.cartSize
			},
			b2bUnit: pcTrunk.b2bUnit,
			mvMotor: pcTrunk.mvMotorProduct,
			registerForm: pcTrunk.registerForm,
			buyerTypes: pcTrunk.buyerTypes,
			error: pcTrunk.errorMessage
		};

		app.config = config;
		app.constants = constants;
		app.pages = pages;
		app.stash = stash;

		var cacheCheck = function () {

			if (window.sessionStorage != null) {
				window.sessionStorage.clear();
			}

			if (window.localStorage == null) {
				app.config.caching = false;
			} else {
				var ver = localStorage.getItem("ver");
				if (ver == null || ver != app.ver) {
					localStorage.clear();
					localStorage.setItem("ver", app.ver);
				}
			}

		};

		var cleanInitData = function () {
			delete window.pcTrunk;
			$("#pc-trunk").remove();
		};

		cacheCheck();
		cleanInitData();
	};

	window.appSetup = appSetup;

})(window.appSetup || {});
